import React from 'react';
import EmailBulkModal from './EmailBulkModal';

export default function EmailAllPartsZipPopup(args) {
  return <EmailBulkModal {...args} topBarTitle="Email ZIP File" emailActionName="emailPartsZip" />;
}



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailAllPartsZipPopup.jsx